import { Consumer, createConsumer } from "@rails/actioncable";

const URL = import.meta.env.VITE_WEBSOCKET_SERVER_URL;

type ConsumerType = typeof Consumer;

let consumer: ConsumerType;

const getServerConnection = (): ConsumerType => {
  return (consumer = consumer || createConsumer(URL));
};

export default getServerConnection;
